/**
 * Verification-scoped point-cloud visibility.
 *
 * The global `showPointCloud(name, false)` contract intentionally disposes the
 * octree and GPU resources. Verification needs a faster compare loop: hide
 * retains the loaded group and octree, show reuses them, while scan switches
 * and route teardown explicitly dispose through `disposePointCloudByName`.
 */
import { log as debugLog, error as debugError } from '@/utils/debugLogger';

export function setScanVisibility({
  store, mainExt, name, visible, url,
}) {
  if (!store || !name || typeof mainExt?.setPointCloudVisibility !== 'function') {
    debugLog('[scanVisibility] skipped', {
      name,
      visible,
      hasStore: !!store,
      hasRetainedVisibility: typeof mainExt?.setPointCloudVisibility === 'function',
    });
    return false;
  }

  try {
    store.commit('SET_POINT_CLOUD_SHOWN', { name, isShown: visible });
    const retained = mainExt.setPointCloudVisibility(name, visible);

    if (visible && !retained) {
      if (!url || typeof mainExt.showPointCloud !== 'function') {
        debugError('[scanVisibility] show requested without a loadable URL', { name });
        store.commit('SET_POINT_CLOUD_SHOWN', { name, isShown: false });
        return false;
      }
      mainExt.showPointCloud(name, true, url);
    }

    mainExt.updatePointClouds?.();
    debugLog('[scanVisibility] applied', {
      name,
      visible,
      retained,
      shownClouds: mainExt.getshownPointClouds?.().length ?? null,
    });
    return true;
  } catch (err) {
    debugError('[scanVisibility] failed', {
      name, visible, err,
    });
    return false;
  }
}

export default setScanVisibility;
